import { Grid, GridItem } from '@imported/constellation';
import React from 'react';
import { PageHeading, ScanDocumentForm } from '../../components/index.js';
import NeedHelp from '../../components/NeedHelp/index.js';
import { useIdvProvider } from '../../context/index.js';
import { useLabelContext } from '../../context/LabelContext.js';
import { DocType } from '../../types/identityContextTypes.js';
const SelfiePhoto = () => {
    const { idvState } = useIdvProvider();
    const { getLabelFromContext } = useLabelContext();
    return (React.createElement(React.Fragment, null,
        React.createElement(PageHeading, { journeyTitle: idvState.labels.applicationHeading, pageTitle: getLabelFromContext('containers.proofOfIdentity.pageTitle') }),
        React.createElement(Grid, null,
            React.createElement(GridItem, { md: 8, sm: 12 },
                React.createElement(ScanDocumentForm, { docType: DocType.SELFIE })),
            React.createElement(GridItem, { md: 4, sm: 12 },
                React.createElement(NeedHelp, null)))));
};
export default SelfiePhoto;
//# sourceMappingURL=index.js.map